import * as Yup from 'yup';

const AcquirerSchema = Yup.object().shape({
  acquirerId: Yup.string().required('Aquirer required'),
  merchantId: Yup.string().required('Merchant ID is required')
});

export default AcquirerSchema;
